module.exports = __webpack_public_path__ + "static/media/instructivoa2.81cfdd83.png";